/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';
import { useCreateAreaTag } from '../hooks/hooks';

interface StatusBarProps {
  mode: string;
  scale: number;
  photoIndexMode: boolean;
  selectedMarkers: Set<number>;
  savePhotoMarkersMutation: any;
  currentPolygon: any;
  showCoordinates: boolean;
  isHorizontalConstrained: boolean;
  isVerticalConstrained: boolean;
  setShowCoordinates: (show: boolean) => void;
}

const StatusBar = ({
  mode,
  scale,
  photoIndexMode,
  selectedMarkers,
  savePhotoMarkersMutation,
  currentPolygon,
  showCoordinates,
  isHorizontalConstrained,
  isVerticalConstrained,
  setShowCoordinates,
}: StatusBarProps) => {
  const createAreaTagMutation = useCreateAreaTag();

  return (
    <div className="bg-card border-t border-border p-2 flex justify-between items-center text-sm text-muted-foreground data-testid='status-bar'">
      <div className="flex items-center gap-4">
        <Badge variant="outline">Mode: {mode.charAt(0).toUpperCase() + mode.slice(1)}</Badge>
        <Badge variant="outline">Scale: {(scale * 100).toFixed(0)}%</Badge>
        {photoIndexMode && <Badge variant="outline">Selected: {selectedMarkers.size}</Badge>}
        {createAreaTagMutation.isPending && <Badge variant="outline">Saving Area...</Badge>}
        {savePhotoMarkersMutation.isPending && <Badge variant="outline">Saving Markers...</Badge>}
      </div>

      <div className="flex items-center gap-4">
        {mode === 'measure' && (
          <>
            <span>Points: {currentPolygon.length}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShowCoordinates(!showCoordinates)}
              className="text-primary hover:text-primary/80"
            >
              {showCoordinates ? 'Hide' : 'Show'} Coordinates
            </Button>
          </>
        )}

        {(isHorizontalConstrained || isVerticalConstrained) && (
          <Badge variant="secondary" className="text-amber-600 dark:text-amber-400">
            Constraint: {isHorizontalConstrained ? 'Horizontal' : 'Vertical'}
          </Badge>
        )}
      </div>
    </div>
  );
};

export default StatusBar;
